import { collection, collectionGroup, doc, getDoc, getDocs, query } from 'firebase/firestore';
import { db, auth } from './firebase';


export async function getOwnRank(uid) {
  let rank = 1;
  await getPointCol(uid).then((data) => {
    const ownIndex = calcOwnIndex(data, uid);
    const ownPoint = data[ownIndex].totalPoint;

    for (let i = 0; i < data.length; i++) {
      if (ownIndex === i) continue;
      if (data[i].totalPoint > ownPoint) {
        rank += 1;
      }
    }
  });
  return rank;
}

function calcOwnIndex(data, uid) {
  let ownIndex = null;
  for (let i = 0; i < data.length; i++) {
    if (data[i].id === uid) ownIndex = i;
  }

  return ownIndex;
}

async function getPointCol() {

  const querySnapshot = await getDocs(collection(db, "point"));
  let pointObj = [];
  querySnapshot.forEach((doc) => {
    let tmpObj = {
      id: "",
      totalPoint: null
    };
    tmpObj.id = doc.id;
    tmpObj.totalPoint = doc.data().totalPoint;
    pointObj[pointObj.length] = tmpObj;
  });
  return pointObj;
}
